import React from 'react';
import styled from 'styled-components';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

interface Props {
    values: string[];
}

const InstrumentCluster: React.FC<Props> = props => {
    return (
        <Grid xs={6} component={Stack} container direction="column" item>
            {props.values.map((v, i) =>
                i === 0 ? (
                    <MainValue key={v}>{v}</MainValue>
                ) : (
                    <SubValue key={v}>{v}</SubValue>
                )
            )}
        </Grid>
    );
};

const MainValue = styled(Typography)`
    font-size: 13px;
    font-weight: 500;
`;

const SubValue = styled(Typography)`
    color: #697d90;
    font-size: 11px;
    font-weight: 500;
    line-height: 16px;
`;

export default InstrumentCluster;
